import api from "../services/api";

export interface IPartner {
  id: string;
  name: string;
  logoUrl: string;
  displayOrder: number;
}

export interface SavePartnerDTO {
  name: string;
  logoUrl: string;
}

export const getPartners = () => api.get("SitePartner");
export const createPartner = (data: SavePartnerDTO) => api.post("SitePartner", data);
export const updatePartner = (id: string, data: SavePartnerDTO) => api.put(`SitePartner/${id}`, data);
export const deletePartner = (id: string) => api.delete(`SitePartner/${id}`);
export const reorderPartners = (ids: string[]) => api.put("SitePartner/reorder", { ids });
